import { BaseService } from "./BaseService";
import PhotoUploader from "../commons/PhotoUploader";
import Helpers from "../commons/Helpers";
import Collections from "../commons/Collections";

const BASKET_TYPE = "canasta";
export class CompanyService extends BaseService {
  async getCompanyData(id) {
    try {
      return this.http(`app/companies/${id}`, "get", {});
    } catch (error) {
      console.log("ERR ", error);
      return {
        ok: false,
        message: error.message,
      };
    }
  }

  async update(id, data) {
    const response = {
      ok: false,
      message: "",
    };
    try {
      await this.getDocRef(`${Collections.company}/${id}`).update(data);
      response.ok = true;
    } catch (error) {
      response.message = error.message;
    }
    return response;
  }

  async delete(id) {
    const response = {
      ok: false,
      message: "",
    };
    try {
      await this.getDocRef(`${Collections.company}/${id}`).delete();
      response.ok = true;
    } catch (error) {
      response.message = error.message;
    }
    return response;
  }

  async deleteBasket(companyId, basketId) {
    try {
      return this.http(
        `app/companies/${companyId}/baskets/${basketId}`,
        "delete"
      );
    } catch (error) {
      console.log("ERR ", error);
      return {
        ok: false,
        message: error.message,
      };
    }
  }

  async getCompanies(userCompanies) {
    try {
      return this.http(`app/getNewCompanies`, "get", {});
    } catch (error) {
      console.log("ERR ", error);
      return {
        ok: false,
        message: error.message,
      };
    }
  }
  async getServices() {
    try {
      return this.http(`app/getServices`, "get", {});
    } catch (error) {
      console.log("ERR ", error);
      return {
        ok: false,
        message: error.message,
      };
    }
  }
  async getCompanyByID(id) {
    try {
      return this.http(`app/getNewCompanies/${id}`, "get", {});
    } catch (error) {
      console.log("ERR ", error);
      return {
        ok: false,
        message: error.message,
      };
    }
  }
  async getServiceByID(id) {
    try {
      return this.http(`app/getServiceById/${id}`, "get", {});
    } catch (error) {
      console.log("ERR ", error);
      return {
        ok: false,
        message: error.message,
      };
    }
  }
  async getProvinces() {
    try {
      return this.http(`app/provinces`, "get", {});
    } catch (error) {
      console.log("ERR ", error);
      return {
        ok: false,
        message: error.message,
      };
    }
  }
  async getGalery(id) {
    try {
      return this.http(`app/getGaleryDetail/${id}`, "get", {});
    } catch (error) {
      console.log("ERR ", error);
      return {
        ok: false,
        message: error.message,
      };
    }
  }
  async getMedia(id) {
    try {
      return this.http(`app/getMediaDetail/${id}`, "get", {});
    } catch (error) {
      console.log("ERR ", error);
      return {
        ok: false,
        message: error.message,
      };
    }
  }
  async deleteGalery(id) {
    try {
      return this.http(`app/deleteGalery/${id}`, "delete", {});
    } catch (error) {
      console.log("ERR ", error);
      return {
        ok: false,
        message: error.message,
      };
    }
  }
  async deleteMedia(id) {
    try {
      return this.http(`app/deleteAdversiting/${id}`, "delete", {});
    } catch (error) {
      console.log("ERR ", error);
      return {
        ok: false,
        message: error.message,
      };
    }
  }
  async getCompanyBaskets(companyId) {
    const response = {
      ok: false,
      message: "",
      baskets: [],
    };
    const path = `${Collections.company}/${companyId}/${Collections.category}`;
    try {
      const snapshot = await this.getCollectionRef(path)
        .where("type", "==", BASKET_TYPE)
        .get();
      response.baskets = snapshot.docs.map((x) => {
        const data = x.data();
        return {
          id: x.id,
          name: data.name,
          photo: data.photo,
          price: data.price,
          description: data.description,
          loading: false,
        };
      });
      response.ok = true;
    } catch (error) {
      response.message = error.message;
    }
    return response;
  }

  async getCompanyProducts(companyId, noLimit, metadata, categoryId) {
    const url = `app/companies/${companyId}/products?noLimit=${noLimit}&metadata=${
      metadata || 0
    }&categoryId=${categoryId || 0}`;
    try {
      return this.http(url, "get", {});
    } catch (error) {
      console.log("ERR ", error);
      return {
        ok: false,
        message: error.message,
      };
    }
  }

  async importProducts(company, products, convertionRate, user) {
    try {
      return this.http(`app/importProducts`, "post", {
        company,
        products,
        convertionRate,
        user,
      });
    } catch (error) {
      console.log("ERR ", error);
      return {
        ok: false,
        message: error.message,
      };
    }
  }

  async setProduct(
    companyId,
    productId,
    productData,
    photoFile,
    progressCallback,
    userId
  ) {
    const response = {
      ok: false,
      message: "",
      product: {},
    };
    const path = `${Collections.company}/${companyId}/${Collections.products}`;
    try {
      let newDoc = null;
      if (productId) {
        const productRef = this.getCollectionRef(path).doc(productId);
        await productRef.collection(Collections.modifications).add({
          user_id: userId,
          date: this.getServerTimestamp(),
        });
        newDoc = await productRef.set(productData, { merge: true });
      } else {
        productData["created_by"] = userId;
        newDoc = await this.getCollectionRef(path).add(productData);
        productId = newDoc.id;
      }

      if (photoFile) {
        console.log("save photo");
        const photoUpload = await PhotoUploader.upload(
          "Products",
          productId,
          photoFile,
          progressCallback
        );

        await this.getCollectionRef(path).doc(productId).set(
          {
            photo: photoUpload.url,
            photo_ref: photoUpload.fileNameRef,
          },
          { merge: true }
        );
      }

      response.ok = true;
      response.product = newDoc;
    } catch (error) {
      response.message = error.message;
    }
    return response;
  }

  async saveBasket(
    companyId,
    basketId,
    name,
    description,
    products,
    photo,
    progressCallback
  ) {
    let method = "post";
    let url = `app/companies/${companyId}/baskets`;
    if (basketId) {
      method = "put";
      url = `app/companies/${companyId}/baskets/${basketId}`;
    }
    try {
      return this.http(
        url,
        method,
        {
          name,
          description,
          products,
          photo,
        },
        progressCallback
      );
    } catch (error) {
      console.log("ERR ", error);
      return {
        ok: false,
        message: error.message,
      };
    }
  }

  async addAdvertising(documents) {
    let method = "post";
    let url = `app/saveAdvertising`;

    try {
      return this.http(url, method, documents);
    } catch (error) {
      console.log("ERR ", error);
      return {
        ok: false,
        message: error.message,
      };
    }
  }
  async updateAlbum(album) {
    let method = "put";
    let url = `app/updateAlbum`;

    try {
      return this.http(url, method, album);
    } catch (error) {
      console.log("ERR ", error);
      return {
        ok: false,
        message: error.message,
      };
    }
  }

  async updateMedia(album) {
    let method = "put";
    let url = `app/updateMedia`;
    try {
      return this.http(url, method, album);
    } catch (error) {
      console.log("ERR ", error);
      return {
        ok: false,
        message: error.message,
      };
    }
  }

  async getAdvertisings() {
    try {
      return this.http(`app/getAdvertisings`, "get", {});
    } catch (error) {
      console.log("ERR ", error);
      return {
        ok: false,
        message: error.message,
      };
    }
  }
  async getGalries() {
    try {
      return this.http(`app/getGaleries`, "get", {});
    } catch (error) {
      console.log("ERR ", error);
      return {
        ok: false,
        message: error.message,
      };
    }
  }

  async removeMedia(media) {
    try {
      return this.http(`app/deleteAdversiting/${media.Id}`, "get", {});
    } catch (error) {
      console.log("ERR ", error);
      return {
        ok: false,
        message: error.message,
      };
    }
  }
  async getEstablishmentTypes() {
    const types = await this.getCollectionRef(
      Collections.establishmentType
    ).get();
    let output = [];
    types.forEach((type) => {
      const data = type.data();
      output.push({
        id: type.id,
        name: data.name,
        position: data.position,
      });
    });
    return output;
  }

  getEstablishmentName(id, types) {
    let name = "N/D";
    for (let i = 0; i < types.length; i++) {
      if (types[i].id == id) {
        name = types[i].name;
        break;
      }
    }
    return name;
  }

  createCompanyObject(companySnapshot) {
    const data = companySnapshot.data();
    return {
      id: companySnapshot.id,
      status: data.status,
      name: data.name,
      photo: data.photo || "",
      photoRef: data.photo_ref || "",
      provinces: data.provinces,
      totalOrders: data.Total_orders || 0,
      type: data.type,
      minimum: data.minimum,
      shippingCost: data.shipping_cost,
      location: data.location,
      companyId: data.company_id || "",
      address: data.address || "",
      currency: data.currency || "",
    };
  }

  async addCompany(data) {
    try {
      return this.http(`app/saveNewCompany`, "post", data);
    } catch (error) {
      console.log("ERR ", error);
      return {
        ok: false,
        message: error.message,
      };
    }
  }
  async addService(data) {
    try {
      return this.http(`app/saveService`, "post", data);
    } catch (error) {
      console.log("ERR ", error);
      return {
        ok: false,
        message: error.message,
      };
    }
  }
  async updateService(data) {
    try {
      return this.http(`app/updateService`, "put", data);
    } catch (error) {
      console.log("ERR ", error);
      return {
        ok: false,
        message: error.message,
      };
    }
  }

  async updateCompany(data) {
    try {
      return this.http(`app/updateNewCompany`, "put", data);
    } catch (error) {
      console.log("ERR ", error);
      return {
        ok: false,
        message: error.message,
      };
    }
  }

  async getProductCategories(companyId) {
    const tempList = [];
    const ref = this.getCollectionRef(
      `${Collections.company}/${companyId}/${Collections.category}`
    );
    const snapshot = await ref.get();
    snapshot.docs.forEach((category) => {
      const data = category.data();
      if (data.type === "canasta") {
        return;
      }
      tempList.push({
        id: category.id,
        name: data.name,
      });
    });
    return tempList.sort(Helpers.sortArrayAsc);
  }

  async saveCategory(companyId, categoryName, categoryId) {
    const response = {
      ok: false,
      message: "",
      category: {
        name: categoryName,
        id: "",
      },
    };
    try {
      categoryName = String(categoryName).trim();
      const collectionRef = this.getCollectionRef(
        `${Collections.company}/${companyId}/${Collections.category}`
      );
      const existingCategory = await collectionRef
        .where("name", "==", categoryName)
        .get();
      const nameExists = existingCategory.docs.length > 0;

      if (
        categoryId &&
        nameExists &&
        existingCategory.docs[0].id !== categoryId
      ) {
        response.message = "Ya existe una categoria con ese nombre, use otro.";
        return response;
      } else if (nameExists && !categoryId) {
        response.message = "Ya existe una categoria con ese nombre, use otro.";
        return response;
      }

      const docRef = categoryId
        ? collectionRef.doc(categoryId)
        : collectionRef.doc();
      response.category.id = docRef.id;
      await docRef.set({
        name: categoryName,
      });
      response.ok = true;
    } catch (e) {
      response.message = e.message;
    }
    return response;
  }

  async deleteProduct(companyId, id, photoRef) {
    const response = {
      ok: false,
      message: "",
    };
    try {
      await PhotoUploader.deleteFile("Products", photoRef);
      await this.getDocRef(
        `${Collections.company}/${companyId}/${Collections.products}/${id}`
      ).delete();
      response.ok = true;
    } catch (error) {
      response.message = error.message;
    }
    return response;
  }

  async updateEstablishmentTypePosition(id, position) {}

  async getProductPhotos(companyId, productId) {
    const response = {
      ok: false,
      message: "",
      photos: [],
    };
    try {
      const url = `api/getProductPhotos?company_id=${companyId}&product_id=${productId}`;
      const res = await this.http(url, "GET", {});

      response.ok = res.ok;
      response.photos = res.data;
    } catch (error) {
      response.message = error.message;
    }
    return response;
  }

  async getBasket(companyId, basketId) {
    try {
      return this.http(
        `app/companies/${companyId}/baskets/${basketId}`,
        "get",
        {}
      );
    } catch (error) {
      console.log("ERR ", error);
      return {
        ok: false,
        message: error.message,
      };
    }
  }

  async getBasketProducts(companyId, basketId) {
    try {
      return this.http(
        `app/companies/${companyId}/baskets/${basketId}/products`,
        "get",
        {}
      );
    } catch (error) {
      console.log("ERR ", error);
      return {
        ok: false,
        message: error.message,
      };
    }
  }

  async getBaskets(companyId) {
    try {
      return this.http(`app/companies/${companyId}/baskets`, "get", {});
    } catch (error) {
      console.log("ERR ", error);
      return {
        ok: false,
        message: error.message,
      };
    }
  }
}
